// extracted by mini-css-extract-plugin
export default {"dayOfWeek":"DayOfWeek-dayOfWeek-D4GRS","isSingleDay":"DayOfWeek-isSingleDay-w4a3G","isToday":"DayOfWeek-isToday-Ga8JJ"};